module.exports = __webpack_public_path__ + "img/img_pinpaicehua.1f70dfd0.jpg";